export class OrganizationException extends Error {
  public message: string;
  private readonly code: string;

  public constructor(code: string) {
    super();
    this.code = code;
    this.message = this.getErrorMessage();
    Object.setPrototypeOf(this, OrganizationException.prototype);
  }

  private getErrorMessage = (): string => {
    const errorMessages: any = {
      "5000": "El token es invalido.",
      "5001": "El enlace de invitación es inválido/expirado.",
      "5002": "La organización tiene el máximo de miembros permitidos.",
      "5003": "Este perfil ya pertenece a una organización.",
    };

    return errorMessages[this.code] || "Error desconocido";
  };
}
